/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfIListOfUserPrivateNumbersForSendDto } from '../models/custom-result-of-i-list-of-user-private-numbers-for-send-dto';
import { CustomResultOfListOfGetAllDescendantPrivateNumbersDto } from '../models/custom-result-of-list-of-get-all-descendant-private-numbers-dto';
import { CustomResultOfListOfGetAllPrivateNumbersByOrganizationIdDto } from '../models/custom-result-of-list-of-get-all-private-numbers-by-organization-id-dto';
import { CustomResultOfListOfGetCurrentUserPrivateNumbersDto } from '../models/custom-result-of-list-of-get-current-user-private-numbers-dto';
import { CustomResultOfListOfGetPrivateNumbersByUserIdDto } from '../models/custom-result-of-list-of-get-private-numbers-by-user-id-dto';
import { CustomResultOfListOfGetPrivateNumbersForStatisticsDto } from '../models/custom-result-of-list-of-get-private-numbers-for-statistics-dto';
import { CustomResultOfNumberDto } from '../models/custom-result-of-number-dto';
import { CustomResultOfPaginatedListOfGetAllNumbersListDto } from '../models/custom-result-of-paginated-list-of-get-all-numbers-list-dto';
import { CustomResultOfPaginatedListOfGetAllNumbersWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-all-numbers-with-pagination-dto';
import { CustomResultOfPaginatedListOfPrivateNumberDto } from '../models/custom-result-of-paginated-list-of-private-number-dto';
import { privateNumbersCreateGet } from '../fn/private-numbers/private-numbers-create-get';
import { PrivateNumbersCreateGet$Params } from '../fn/private-numbers/private-numbers-create-get';
import { privateNumbersCreatePost } from '../fn/private-numbers/private-numbers-create-post';
import { PrivateNumbersCreatePost$Params } from '../fn/private-numbers/private-numbers-create-post';
import { privateNumbersCreatePrivateNumbersByRangeGet } from '../fn/private-numbers/private-numbers-create-private-numbers-by-range-get';
import { PrivateNumbersCreatePrivateNumbersByRangeGet$Params } from '../fn/private-numbers/private-numbers-create-private-numbers-by-range-get';
import { privateNumbersCreatePrivateNumbersByRangePost } from '../fn/private-numbers/private-numbers-create-private-numbers-by-range-post';
import { PrivateNumbersCreatePrivateNumbersByRangePost$Params } from '../fn/private-numbers/private-numbers-create-private-numbers-by-range-post';
import { privateNumbersDelete } from '../fn/private-numbers/private-numbers-delete';
import { PrivateNumbersDelete$Params } from '../fn/private-numbers/private-numbers-delete';
import { privateNumbersGetAllDescendantPrivateNumbers } from '../fn/private-numbers/private-numbers-get-all-descendant-private-numbers';
import { PrivateNumbersGetAllDescendantPrivateNumbers$Params } from '../fn/private-numbers/private-numbers-get-all-descendant-private-numbers';
import { privateNumbersGetAllNumberListWithPagination } from '../fn/private-numbers/private-numbers-get-all-number-list-with-pagination';
import { PrivateNumbersGetAllNumberListWithPagination$Params } from '../fn/private-numbers/private-numbers-get-all-number-list-with-pagination';
import { privateNumbersGetAllNumbersForOrganizationWithPagination } from '../fn/private-numbers/private-numbers-get-all-numbers-for-organization-with-pagination';
import { PrivateNumbersGetAllNumbersForOrganizationWithPagination$Params } from '../fn/private-numbers/private-numbers-get-all-numbers-for-organization-with-pagination';
import { privateNumbersGetAllPrivateNumbersByOrganizationId } from '../fn/private-numbers/private-numbers-get-all-private-numbers-by-organization-id';
import { PrivateNumbersGetAllPrivateNumbersByOrganizationId$Params } from '../fn/private-numbers/private-numbers-get-all-private-numbers-by-organization-id';
import { privateNumbersGetCurrentUserPrivateNumbers } from '../fn/private-numbers/private-numbers-get-current-user-private-numbers';
import { PrivateNumbersGetCurrentUserPrivateNumbers$Params } from '../fn/private-numbers/private-numbers-get-current-user-private-numbers';
import { privateNumbersGetPrivateNumberAudits } from '../fn/private-numbers/private-numbers-get-private-number-audits';
import { PrivateNumbersGetPrivateNumberAudits$Params } from '../fn/private-numbers/private-numbers-get-private-number-audits';
import { privateNumbersGetPrivateNumbersByUserId } from '../fn/private-numbers/private-numbers-get-private-numbers-by-user-id';
import { PrivateNumbersGetPrivateNumbersByUserId$Params } from '../fn/private-numbers/private-numbers-get-private-numbers-by-user-id';
import { privateNumbersGetPrivateNumbersForStatistics } from '../fn/private-numbers/private-numbers-get-private-numbers-for-statistics';
import { PrivateNumbersGetPrivateNumbersForStatistics$Params } from '../fn/private-numbers/private-numbers-get-private-numbers-for-statistics';
import { privateNumbersGetPrivateNumbersWithPagination } from '../fn/private-numbers/private-numbers-get-private-numbers-with-pagination';
import { PrivateNumbersGetPrivateNumbersWithPagination$Params } from '../fn/private-numbers/private-numbers-get-private-numbers-with-pagination';
import { privateNumbersGetPrivateNumberTransferHistoryAudits } from '../fn/private-numbers/private-numbers-get-private-number-transfer-history-audits';
import { PrivateNumbersGetPrivateNumberTransferHistoryAudits$Params } from '../fn/private-numbers/private-numbers-get-private-number-transfer-history-audits';
import { privateNumbersGetUserPrivateNumbersForSend } from '../fn/private-numbers/private-numbers-get-user-private-numbers-for-send';
import { PrivateNumbersGetUserPrivateNumbersForSend$Params } from '../fn/private-numbers/private-numbers-get-user-private-numbers-for-send';
import { privateNumbersTransferPrivateNumberGet } from '../fn/private-numbers/private-numbers-transfer-private-number-get';
import { PrivateNumbersTransferPrivateNumberGet$Params } from '../fn/private-numbers/private-numbers-transfer-private-number-get';
import { privateNumbersTransferPrivateNumberPost } from '../fn/private-numbers/private-numbers-transfer-private-number-post';
import { PrivateNumbersTransferPrivateNumberPost$Params } from '../fn/private-numbers/private-numbers-transfer-private-number-post';
import { privateNumbersUpdateGet } from '../fn/private-numbers/private-numbers-update-get';
import { PrivateNumbersUpdateGet$Params } from '../fn/private-numbers/private-numbers-update-get';
import { privateNumbersUpdatePut } from '../fn/private-numbers/private-numbers-update-put';
import { PrivateNumbersUpdatePut$Params } from '../fn/private-numbers/private-numbers-update-put';

@Injectable({ providedIn: 'root' })
export class PrivateNumbersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `privateNumbersGetPrivateNumbersWithPagination()` */
  static readonly PrivateNumbersGetPrivateNumbersWithPaginationPath = '/PrivateNumbers/GetPrivateNumbersWithPagination';

  /**
   * Get PrivateNumbers with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetPrivateNumbersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetPrivateNumbersWithPagination$Response(params: PrivateNumbersGetPrivateNumbersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPrivateNumberDto>> {
    return privateNumbersGetPrivateNumbersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get PrivateNumbers with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetPrivateNumbersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetPrivateNumbersWithPagination(params: PrivateNumbersGetPrivateNumbersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPrivateNumberDto> {
    return this.privateNumbersGetPrivateNumbersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPrivateNumberDto>): CustomResultOfPaginatedListOfPrivateNumberDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetPrivateNumberAudits()` */
  static readonly PrivateNumbersGetPrivateNumberAuditsPath = '/PrivateNumbers/GetPrivateNumberAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetPrivateNumberAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetPrivateNumberAudits$Response(params: PrivateNumbersGetPrivateNumberAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return privateNumbersGetPrivateNumberAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetPrivateNumberAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetPrivateNumberAudits(params: PrivateNumbersGetPrivateNumberAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.privateNumbersGetPrivateNumberAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetPrivateNumberTransferHistoryAudits()` */
  static readonly PrivateNumbersGetPrivateNumberTransferHistoryAuditsPath = '/PrivateNumbers/GetPrivateNumberTransferHistoryAudits';

  /**
   * Only for pishgam users, Get all PrivateNumberTransferHistory audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetPrivateNumberTransferHistoryAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetPrivateNumberTransferHistoryAudits$Response(params: PrivateNumbersGetPrivateNumberTransferHistoryAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return privateNumbersGetPrivateNumberTransferHistoryAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all PrivateNumberTransferHistory audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetPrivateNumberTransferHistoryAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetPrivateNumberTransferHistoryAudits(params: PrivateNumbersGetPrivateNumberTransferHistoryAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.privateNumbersGetPrivateNumberTransferHistoryAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetUserPrivateNumbersForSend()` */
  static readonly PrivateNumbersGetUserPrivateNumbersForSendPath = '/PrivateNumbers/GetUserPrivateNumbersForSend';

  /**
   * Get User PrivateNumbers ForSend.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetUserPrivateNumbersForSend()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetUserPrivateNumbersForSend$Response(params?: PrivateNumbersGetUserPrivateNumbersForSend$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfIListOfUserPrivateNumbersForSendDto>> {
    return privateNumbersGetUserPrivateNumbersForSend(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User PrivateNumbers ForSend.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetUserPrivateNumbersForSend$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetUserPrivateNumbersForSend(params?: PrivateNumbersGetUserPrivateNumbersForSend$Params, context?: HttpContext): Observable<CustomResultOfIListOfUserPrivateNumbersForSendDto> {
    return this.privateNumbersGetUserPrivateNumbersForSend$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfIListOfUserPrivateNumbersForSendDto>): CustomResultOfIListOfUserPrivateNumbersForSendDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetAllNumbersForOrganizationWithPagination()` */
  static readonly PrivateNumbersGetAllNumbersForOrganizationWithPaginationPath = '/PrivateNumbers/GetAllNumbersForOrganizationWithPagination';

  /**
   * Get all Numbers list for organization.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetAllNumbersForOrganizationWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetAllNumbersForOrganizationWithPagination$Response(params: PrivateNumbersGetAllNumbersForOrganizationWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetAllNumbersListDto>> {
    return privateNumbersGetAllNumbersForOrganizationWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all Numbers list for organization.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetAllNumbersForOrganizationWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetAllNumbersForOrganizationWithPagination(params: PrivateNumbersGetAllNumbersForOrganizationWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetAllNumbersListDto> {
    return this.privateNumbersGetAllNumbersForOrganizationWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetAllNumbersListDto>): CustomResultOfPaginatedListOfGetAllNumbersListDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetAllNumberListWithPagination()` */
  static readonly PrivateNumbersGetAllNumberListWithPaginationPath = '/PrivateNumbers/GetAllNumberListWithPagination';

  /**
   * Get all Numbers With Pagination PrivateNumbers ReceiveKeywords - use for superAdmin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetAllNumberListWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetAllNumberListWithPagination$Response(params: PrivateNumbersGetAllNumberListWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetAllNumbersWithPaginationDto>> {
    return privateNumbersGetAllNumberListWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all Numbers With Pagination PrivateNumbers ReceiveKeywords - use for superAdmin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetAllNumberListWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersGetAllNumberListWithPagination(params: PrivateNumbersGetAllNumberListWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetAllNumbersWithPaginationDto> {
    return this.privateNumbersGetAllNumberListWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetAllNumbersWithPaginationDto>): CustomResultOfPaginatedListOfGetAllNumbersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersCreateGet()` */
  static readonly PrivateNumbersCreateGetPath = '/PrivateNumbers/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersCreateGet$Response(params?: PrivateNumbersCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumbersCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersCreateGet(params?: PrivateNumbersCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumbersCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumbersCreatePost()` */
  static readonly PrivateNumbersCreatePostPath = '/PrivateNumbers/Create';

  /**
   * Create PrivateNumber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersCreatePost$Response(params: PrivateNumbersCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumbersCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create PrivateNumber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersCreatePost(params: PrivateNumbersCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumbersCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumbersCreatePrivateNumbersByRangeGet()` */
  static readonly PrivateNumbersCreatePrivateNumbersByRangeGetPath = '/PrivateNumbers/CreatePrivateNumbersByRange';

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersCreatePrivateNumbersByRangeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersCreatePrivateNumbersByRangeGet$Response(params?: PrivateNumbersCreatePrivateNumbersByRangeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumbersCreatePrivateNumbersByRangeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * بررسی دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersCreatePrivateNumbersByRangeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersCreatePrivateNumbersByRangeGet(params?: PrivateNumbersCreatePrivateNumbersByRangeGet$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumbersCreatePrivateNumbersByRangeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumbersCreatePrivateNumbersByRangePost()` */
  static readonly PrivateNumbersCreatePrivateNumbersByRangePostPath = '/PrivateNumbers/CreatePrivateNumbersByRange';

  /**
   * ایجاد خطوط اختصاصی بر اساس بازه(گروهی).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersCreatePrivateNumbersByRangePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersCreatePrivateNumbersByRangePost$Response(params: PrivateNumbersCreatePrivateNumbersByRangePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumbersCreatePrivateNumbersByRangePost(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد خطوط اختصاصی بر اساس بازه(گروهی).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersCreatePrivateNumbersByRangePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersCreatePrivateNumbersByRangePost(params: PrivateNumbersCreatePrivateNumbersByRangePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumbersCreatePrivateNumbersByRangePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumbersTransferPrivateNumberGet()` */
  static readonly PrivateNumbersTransferPrivateNumberGetPath = '/PrivateNumbers/TransferPrivateNumber';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersTransferPrivateNumberGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersTransferPrivateNumberGet$Response(params?: PrivateNumbersTransferPrivateNumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return privateNumbersTransferPrivateNumberGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersTransferPrivateNumberGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersTransferPrivateNumberGet(params?: PrivateNumbersTransferPrivateNumberGet$Params, context?: HttpContext): Observable<Blob> {
    return this.privateNumbersTransferPrivateNumberGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `privateNumbersTransferPrivateNumberPost()` */
  static readonly PrivateNumbersTransferPrivateNumberPostPath = '/PrivateNumbers/TransferPrivateNumber';

  /**
   * Transfer PrivateNumber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersTransferPrivateNumberPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersTransferPrivateNumberPost$Response(params: PrivateNumbersTransferPrivateNumberPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumbersTransferPrivateNumberPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer PrivateNumber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersTransferPrivateNumberPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersTransferPrivateNumberPost(params: PrivateNumbersTransferPrivateNumberPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumbersTransferPrivateNumberPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumbersUpdatePut()` */
  static readonly PrivateNumbersUpdatePutPath = '/PrivateNumbers/Update';

  /**
   * Update PrivateNumber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersUpdatePut$Response(params: PrivateNumbersUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumbersUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update PrivateNumber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  privateNumbersUpdatePut(params: PrivateNumbersUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumbersUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumbersUpdateGet()` */
  static readonly PrivateNumbersUpdateGetPath = '/PrivateNumbers/Update/{numberId}';

  /**
   * Get Number by numberId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersUpdateGet$Response(params: PrivateNumbersUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfNumberDto>> {
    return privateNumbersUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Number by numberId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersUpdateGet(params: PrivateNumbersUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfNumberDto> {
    return this.privateNumbersUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfNumberDto>): CustomResultOfNumberDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersDelete()` */
  static readonly PrivateNumbersDeletePath = '/PrivateNumbers/Delete';

  /**
   * Delete PrivateNumber.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersDelete$Response(params?: PrivateNumbersDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return privateNumbersDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete PrivateNumber.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersDelete(params?: PrivateNumbersDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.privateNumbersDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetPrivateNumbersForStatistics()` */
  static readonly PrivateNumbersGetPrivateNumbersForStatisticsPath = '/PrivateNumbers/GetPrivateNumbersForStatistics';

  /**
   * دریافت لیست خطوط برای آمار.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetPrivateNumbersForStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetPrivateNumbersForStatistics$Response(params?: PrivateNumbersGetPrivateNumbersForStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetPrivateNumbersForStatisticsDto>> {
    return privateNumbersGetPrivateNumbersForStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست خطوط برای آمار.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetPrivateNumbersForStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetPrivateNumbersForStatistics(params?: PrivateNumbersGetPrivateNumbersForStatistics$Params, context?: HttpContext): Observable<CustomResultOfListOfGetPrivateNumbersForStatisticsDto> {
    return this.privateNumbersGetPrivateNumbersForStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetPrivateNumbersForStatisticsDto>): CustomResultOfListOfGetPrivateNumbersForStatisticsDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetAllDescendantPrivateNumbers()` */
  static readonly PrivateNumbersGetAllDescendantPrivateNumbersPath = '/PrivateNumbers/GetAllDescendantPrivateNumbers';

  /**
   * دریافت لیست خطووط سازمان فعلی و زیرمجموعه ها.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetAllDescendantPrivateNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetAllDescendantPrivateNumbers$Response(params?: PrivateNumbersGetAllDescendantPrivateNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetAllDescendantPrivateNumbersDto>> {
    return privateNumbersGetAllDescendantPrivateNumbers(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست خطووط سازمان فعلی و زیرمجموعه ها.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetAllDescendantPrivateNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetAllDescendantPrivateNumbers(params?: PrivateNumbersGetAllDescendantPrivateNumbers$Params, context?: HttpContext): Observable<CustomResultOfListOfGetAllDescendantPrivateNumbersDto> {
    return this.privateNumbersGetAllDescendantPrivateNumbers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetAllDescendantPrivateNumbersDto>): CustomResultOfListOfGetAllDescendantPrivateNumbersDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetAllPrivateNumbersByOrganizationId()` */
  static readonly PrivateNumbersGetAllPrivateNumbersByOrganizationIdPath = '/PrivateNumbers/GetAllPrivateNumbersByOrganizationId';

  /**
   * دریافت لیست کلیه خطوط سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetAllPrivateNumbersByOrganizationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetAllPrivateNumbersByOrganizationId$Response(params?: PrivateNumbersGetAllPrivateNumbersByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetAllPrivateNumbersByOrganizationIdDto>> {
    return privateNumbersGetAllPrivateNumbersByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست کلیه خطوط سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetAllPrivateNumbersByOrganizationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetAllPrivateNumbersByOrganizationId(params?: PrivateNumbersGetAllPrivateNumbersByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetAllPrivateNumbersByOrganizationIdDto> {
    return this.privateNumbersGetAllPrivateNumbersByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetAllPrivateNumbersByOrganizationIdDto>): CustomResultOfListOfGetAllPrivateNumbersByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetCurrentUserPrivateNumbers()` */
  static readonly PrivateNumbersGetCurrentUserPrivateNumbersPath = '/PrivateNumbers/GetCurrentUserPrivateNumbers';

  /**
   * دریافت لیست کلیه خطوط کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetCurrentUserPrivateNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetCurrentUserPrivateNumbers$Response(params?: PrivateNumbersGetCurrentUserPrivateNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetCurrentUserPrivateNumbersDto>> {
    return privateNumbersGetCurrentUserPrivateNumbers(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست کلیه خطوط کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetCurrentUserPrivateNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetCurrentUserPrivateNumbers(params?: PrivateNumbersGetCurrentUserPrivateNumbers$Params, context?: HttpContext): Observable<CustomResultOfListOfGetCurrentUserPrivateNumbersDto> {
    return this.privateNumbersGetCurrentUserPrivateNumbers$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetCurrentUserPrivateNumbersDto>): CustomResultOfListOfGetCurrentUserPrivateNumbersDto => r.body)
    );
  }

  /** Path part for operation `privateNumbersGetPrivateNumbersByUserId()` */
  static readonly PrivateNumbersGetPrivateNumbersByUserIdPath = '/PrivateNumbers/GetPrivateNumbersByUserId';

  /**
   * دریافت لیست کلیه خطوط کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `privateNumbersGetPrivateNumbersByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetPrivateNumbersByUserId$Response(params?: PrivateNumbersGetPrivateNumbersByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetPrivateNumbersByUserIdDto>> {
    return privateNumbersGetPrivateNumbersByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست کلیه خطوط کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `privateNumbersGetPrivateNumbersByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  privateNumbersGetPrivateNumbersByUserId(params?: PrivateNumbersGetPrivateNumbersByUserId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetPrivateNumbersByUserIdDto> {
    return this.privateNumbersGetPrivateNumbersByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetPrivateNumbersByUserIdDto>): CustomResultOfListOfGetPrivateNumbersByUserIdDto => r.body)
    );
  }

}
